module.exports = __webpack_public_path__ + "5989a235e78aaa6f154c37e766552b63.svg";


//////////////////
// WEBPACK FOOTER
// ./node_modules/react-flag-kit/assets/PH.svg
// module id = 9tO6
// module chunks = 0